export default __webpack_public_path__ + "d87499b92ba05e7cd205f2906a954ec2.svg";